import { useRef } from 'react';
import { usePrefetchEventOnVisible } from '../hooks/queries/usePrefetch';

/** Prefetches event detail when the wrapped card enters the viewport. */
export default function PrefetchEventOnVisible({ eventId, children }) {
  const ref = useRef(null);
  usePrefetchEventOnVisible(eventId, ref);
  return <div ref={ref}>{children}</div>;
}
